import BossModel from "@/models/BossModel";
import WebsiteBlog from "@/models/WebsiteBlog/WebsiteBlog";
import WebsitePage from "@/models/WebsitePage/WebsitePage";
import WebsiteFilterPage from "@/models/WebsiteFilterPage/WebsiteFilterPage";
import Product from "@/models/Product/Product";
import Package from "@/models/Package/Package";
// import Item from "@/models/WebsiteWidget/Accordion/Item/Item";
// import Information from "@/models/WebsiteWidget/Information/Information";
import WebsiteFooterLink from "@/models/WebsiteFooterLink/WebsiteFooterLink";

export default class WebsiteRoute extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-route';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteRoutes';

    static fields() {
		return {
			id: this.number(null).nullable(),
			url: this.attr(null),
            routeable_type: this.attr(null),
			routeable_id: this.number(null).nullable(),
			action: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			meta_title: this.attr(null),
			meta_description: this.attr(null),
			is_no_index: this.boolean(null),
			is_no_follow: this.boolean(null),
			canonicle_website_route_id: this.number(null).nullable(),
            canonicleWebsiteRoute: this.belongsTo(this, 'canonicle_website_route_id'),
            // connectedBlogs: this.belongsToMany(WebsiteBlog),
            // connectedAccordionItems: this.belongsToMany(Item),
            // connectedWidgetInformations: this.belongsToMany(Information),
            websiteFooterLinks: this.hasMany(WebsiteFooterLink, 'website_route_id'),
            website_blog: this.belongsTo(WebsiteBlog, 'website_route_id'),
            website_page: this.belongsTo(WebsitePage, 'website_route_id'),
            website_filter_page: this.belongsTo(WebsiteFilterPage, 'website_route_id'),
            product: this.belongsTo(Product, 'website_route_id'),
            package: this.belongsTo(Package, 'website_route_id'),
		}
	}

    /**
     *
     * @param routeableId
     * @param routeableType
     * @returns {*}
     */
    static findByRouteable(routeableId, routeableType) {
        return this.all().find(item => item.routeable_id === routeableId && item.routeable_type === routeableType);
    }

    /**
     *
     * @param id
     * @returns {*}
     */
    static fetchWithReferences(id) {
        return this.api().with([
            'connectedBlogs',
            'connectedAccordionItems',
            'connectedWidgetInformations',
            'websiteFooterLinks',
            'routeable',
        ]).appended(['connectedCount']).find(id, false);
    }

    /**
     *
     * @param id
     * @returns {*}
     */
    static loadAndCommit(id) {
        return this.api().with(['routeable']).find(id);
    }

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(50)
            .ordered({'url': 'asc'})
            .get().then((data) => {
            let instances = [];
            for (let key in data) {
                instances.push(new WebsiteRoute(data[key]));
            }
            return instances;
        });
    }

    /**
     *
     * @param filters
     * @returns {*}
     */
    static get(filters = {}) {
        return this.api()
            .filtered(filters)
            .limit(0)
            .ordered({url:'asc'})
            .appended(['childrenCount'])
            .get();
    }

    /**
     *
     * @param filters
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static getWithParents(filters = {}) {
        return this.api().action('with_parents')
            .filtered(filters)
            .limit(0)
            .ordered({url:'asc'})
            .appended(['childrenCount'])
            .get();
    }

    /**
     *
     * @returns {number}
     * @constructor
     */
    GetLevel() {
        return (this.url.match(/\//g) || []).length;
    }

    /**
     *
     * @returns {string}
     * @constructor
     */
    LastUrlPart() {
        return this.url.substr(this.url.lastIndexOf('/') + 1);
    }

    /**
     *
     * @returns {boolean}
     * @constructor
     */
    IsPublished() {
        return this.url !== null;
    }

    /**
     *
     * @param activeWebsiteRoute
     * @returns {boolean}
     * @constructor
     */
    IsParentFrom(activeWebsiteRoute) {
        return activeWebsiteRoute.url.startsWith(this.url + '/');
    }

    /**
     *
     * @param activeWebsiteRoute
     * @returns {boolean|boolean}
     * @constructor
     */
    IsChildFrom(activeWebsiteRoute) {
        return this.url.startsWith(activeWebsiteRoute.url + '/') && this.GetLevel() === activeWebsiteRoute.GetLevel() + 1;
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    WebsiteBlog() {
        if (this.routeable_type === 'website_blog') {
            return this.getRelated('website_blog');
        }

        return false;
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    WebsitePage() {
        if (this.routeable_type === 'website_page') {
            return this.getRelated('website_page');
        }

        return false;
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    WebsiteFilterPage() {
        if (this.routeable_type === 'website_filter_page') {
            return this.getRelated('website_filter_page');
        }

        return false;
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Product() {
        if (this.routeable_type === 'product') {
            return this.getRelated('product');
        }

        return false;
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Package() {
        if (this.routeable_type === 'package') {
            return this.getRelated('package');
        }

        return false;
    }

}
